import { observable, action, runInAction } from "mobx";
import { Dialog } from "@weapp/ui";
import * as API from "../../../api/AppManage";
import { sortBy } from '../../../utils'
import { getLabel } from "@weapp/utils";
const { message } = Dialog;

class AppManageDialogStore {
  @observable apps: any = [];
  @observable groupTitles: any = [];
  @action
  init = () => {
    this.getApps();
  };
  @action
  getApps = () => {
    API.getAppModules().then((data: any) => {
      if (data && data.empmenus) {
        runInAction(() => {
          data.empmenus.forEach((menu: any) => {
            menu.menuStatus = Boolean(Number(menu.menuStatus));
            // menu.disabled = false;
            // if(menu.applicationType === 'freeUrl'){
            //   //内部链接应用不能开启
            //   if(menu.applicationCustoms && menu.applicationCustoms[0] && menu.applicationCustoms[0].innerUrl){
            //     menu.disabled = true;
            //   }
            // }
          });
          data.empmenus.sort(sortBy("orderIndex"));
          this.apps = data.empmenus;
        });
      }

      console.log(data);
    });
  };
  @action
  updateModule = (data: any) => {
    API.updateMoudles(data).then(() => {
      message({
        type: "success",
        content: getLabel('61310', "更新成功,刷新页面后生效"),
      });
    });
  };
  @action
  updateModuleOrder = (data: any) => {
    API.updateModuleOrder(data).then(() => {
      message({
        type: "success",
        content: getLabel('61310', "更新成功,刷新页面后生效"),
      });
    });
  };
  @action
  resetModules = () => {
    API.resetMoudles().then(() => {
      message({
        type: "success",
        content: getLabel('62277', "重置成功,刷新页面后生效"),
      });
    });
  };
}

const instance = new AppManageDialogStore();

export default instance;
